import { render, staticRenderFns } from "./ResidentsForCooperationSystemTable.vue?vue&type=template&id=8d42d3a4&scoped=true&lang=pug"
import script from "./ResidentsForCooperationSystemTable.vue?vue&type=script&lang=ts"
export * from "./ResidentsForCooperationSystemTable.vue?vue&type=script&lang=ts"
import style0 from "./ResidentsForCooperationSystemTable.vue?vue&type=style&index=0&id=8d42d3a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d42d3a4",
  null
  
)

export default component.exports